var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.3066,
    y: 27.7148,
    width: 27.3694,
    height: 27.3694,
    rx: 4.33349,
    transform: "rotate(-180 28.3066 27.7148)",
    stroke: "#1E1E1E",
    strokeWidth: 0.456157
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5305 6.446L17.6647 12.5802C18.3891 13.3046 18.3891 14.49 17.6647 15.2145L11.5305 21.3486",
    stroke: "#1E1E1E",
    strokeWidth: 2.48146,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.19e89acf9f8d1a59ab137a4a9697ac73.svg";
export { ForwardRef as ReactComponent };